export const REQUEST_SEARCH = "REQUEST_SEARCH";
export const RECEIVE_SEARCH = "RECEIVE_SEARCH";

export const UPDATE_MULTI_FACET = "UPDATE_MULTI_FACET";
export const UPDATE_RANGE_FACET = "UPDATE_RANGE_FACET";
export const UPDATE_SORT_FACET = "UPDATE_SORT_FACET";
export const UPDATE_PERSONALISATION_PARAMS = "UPDATE_PERSONALISATION_PARAMS";
export const SET_ADDITIONAL_QUERY_PARAMS = "SET_ADDITIONAL_QUERY_PARAMS";
export const SET_RANGE_VALUES = "SET_RANGE_VALUES";
export const UNDO_RANGE_VALUES = "UNDO_RANGE_VALUES";
export const CLEAR_RANGE_FACET = "CLEAR_RANGE_FACET";
export const CLEAR_SELECTIONS = "CLEAR_SELECTIONS";

export const MORE_PRODUCTS_LOADED = "MORE_PRODUCTS_LOADED";
export const PREVIOUS_PRODUCTS_LOADED = "PREVIOUS_PRODUCTS_LOADED";
export const LOADING_MORE_PRODUCTS = "LOADING_MORE_PRODUCTS";
export const LOADING_PREVIOUS_PRODUCTS = "LOADING_PREVIOUS_PRODUCTS";
export const SET_NEW_SEARCH = "SET_NEW_SEARCH";
export const CLEAR_NEW_SEARCH = "CLEAR_NEW_SEARCH";
export const RESTORE_OLD_SELECTED_FACETS = "RESTORE_OLD_SELECTED_FACETS";

export const MOBILE_DONE = "MOBILE_DONE";
export const MOBILE_VIEW_ITEMS = "MOBILE_VIEW_ITEMS";

export const ANCHOR_PRODUCT = "ANCHOR_PRODUCT";

export const COLOUR_FACET_GROUP = "SupplierColour";
